import LinksActions from '../../../actions/LinksActions';

export const actions = {
    getDataLink(id, success) {
        const params = {
            ids: id
        };

        LinksActions.getListLinks(params, (response) => {
            success && success(response.items[0]);
        }, {});
    },
};
